import * as api from '../../api/api-trazabilidad-hitos';
import { 
    GET_CONFIG_FORM18,
    GET_GRILLA_BUSQUEDA,
    GET_COMBO_TIPO_GESTION,
    GET_COMBO_CAMBIAR_AMBITO_GESTION,
    GET_DATOS_GESTION
   
} from '../types';

export const configuracionFormAction18 = (query) => ({
    type: GET_CONFIG_FORM18,
    payload: api.getConfiguracionForm18(query)
});
export const obtenerGrillaBusqueda = (query) => ({
    type: GET_GRILLA_BUSQUEDA,
    payload: api.getGrillaBusqueda(query)
});
export const obtenerComboTipoGestion = (query) => ({
    type: GET_COMBO_TIPO_GESTION,
    payload: api.getComboTipoGestion(query)
});
export const obtenerComboCambiarAmbitoGestion = (query) => ({
    type: GET_COMBO_CAMBIAR_AMBITO_GESTION,
    payload: api.getComboAmbitoGestion(query)
});
export const obtenerDatosGestion = (query) => ({
    type: GET_DATOS_GESTION,
    payload: api.getDatosGestion(query)
});